const {
  VITE_ADVERT_API: ADVERT_API = '',
  VITE_DATASOURCE_API: DATASOURCE_API = '',
  VITE_GOOGLE_MAPS_API_KEY: GOOGLE_MAPS_API_KEY = '',
  VITE_APPLY_API: APPLY_API = '',
  MODE: ENVIRONMENT,
  VITE_GIT_INFO: GIT_INFO,
  VITE_PHU_GTM: PHU_GTM,
  VITE_DATA_REQUEST_API: DATA_REQUEST_API = '',
  VITE_DATA_REQUEST_POST_API: DATA_REQUEST_POST_API = '',
} = import.meta.env;

export {
  ADVERT_API,
  DATASOURCE_API,
  GOOGLE_MAPS_API_KEY,
  APPLY_API,
  ENVIRONMENT,
  GIT_INFO,
  DATA_REQUEST_API,
  DATA_REQUEST_POST_API,
  PHU_GTM
};
